import { HelpCircle } from 'lucide-react';
import { useOnboardingStore } from '../../store/onboardingStore';

export function OnboardingTrigger() {
  const { openTOC, completedTours, hasSeenWelcomePrompt } = useOnboardingStore();

  // Show pulse animation if user hasn't completed any tours
  const showPulse = !hasSeenWelcomePrompt || completedTours.length === 0;

  return (
    <button
      onClick={openTOC}
      className={`fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg hover:shadow-xl transition-all flex items-center justify-center ${
        showPulse ? 'animate-pulse' : ''
      }`}
      aria-label="Open help and tutorials"
      title="Help & Tutorials"
    >
      <HelpCircle className="w-6 h-6" />
      {showPulse && (
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-amber-400 rounded-full border-2 border-white dark:border-gray-900" />
      )}
    </button>
  );
}
